import { calculateAttorneyFee } from "@/lib/utils/attorneyFeeUtils";

export const calculateNetSettlementAmount = (
  amount: number | string,
  medPay: boolean,
  medPayRefund: boolean,
  medPayRefundAmount: number | string,
) => {
  if (medPay && medPayRefund) {
    return Number(amount) - Number(medPayRefundAmount);
  }
  return Number(amount);
};

export const calculateSettlementTotals = (
  settlements: {
    amount: number | string;
    accepted: boolean;
    attorneyFeePercentage: number;
    medPay: boolean;
    medPayRefund: boolean;
    medPayRefundAmount: number | string;
  }[],
) => {
  const totalAcceptedSettlements = settlements
    .filter((settlement) => settlement.accepted)
    .reduce(
      (acc, settlement) =>
        acc +
        calculateNetSettlementAmount(
          settlement.amount,
          settlement.medPay,
          settlement.medPayRefund,
          settlement.medPayRefundAmount,
        ),
      0,
    );
  const netToFirm = settlements
    .filter((settlement) => settlement.accepted)
    .reduce(
      (acc, settlement) =>
        acc +
        calculateAttorneyFee(
          calculateNetSettlementAmount(
            settlement.amount,
            settlement.medPay,
            settlement.medPayRefund,
            settlement.medPayRefundAmount,
          ),
          settlement.attorneyFeePercentage,
        ),
      0,
    );

  return {
    totalAcceptedSettlements,
    netToFirm,
  };
};

export const calculateNetToClient = (
  totalSettlementAmount: number,
  totalDeductions: number,
  netToFirm: number,
) => {
  return totalSettlementAmount - totalDeductions - netToFirm;
};
